import { ROUTES } from '@/constants/routes'

export const featured = [
  {
    n: '01',
    title: 'Herbal Consultations',
    tag: 'Most Popular',
    tagColor: 'bg-green-50 text-green-700 border-green-200',
    summary:
      'Personalised one-to-one consultations designed to explore the root causes of imbalance while supporting the body through herbal medicine, nutrition, lifestyle guidance, and holistic wellbeing approaches.',
    supports: [
      "Women's health & hormonal balance",
      'Menstrual health & menopause',
      'Stress & emotional wellbeing',
      'Digestive health',
      'Chronic fatigue',
      'High blood pressure & diabetes support',
      'Immune support & general wellness',
    ],
    availability: 'Available online and in-person',
    path: ROUTES.SERVICES_CONSULTATIONS,
  },
  {
    n: '02',
    title: "Women's Holistic Health",
    tag: 'Specialist',
    tagColor: 'bg-red-50 text-red-600 border-red-200',
    summary:
      'Specialist support for women from menarche to menopause and beyond, using herbal medicine, nutrition, lifestyle guidance, education, and generations of traditional healing knowledge.',
    supports: [
      'Heavy bleeding & fibroids',
      'Painful & irregular periods',
      'Hormonal imbalance & PCOS',
      'Menopause & perimenopause',
      'Fertility support',
      'Emotional wellbeing & womb health',
      'Reproductive wellness',
    ],
    availability: 'Online and in person across the UK and internationally',
    path: ROUTES.WOMENS_HEALTH,
  },
]

export const secondary = [
  {
    n: '03',
    title: 'Integrated Health Consultation + Bio-Scan',
    desc: 'A two-hour consultation and Bio-Scan, with a comprehensive scan report, personalised Integrated Health Report and follow-up Zoom session.',
    path: ROUTES.SERVICES_INTEGRATED_HEALTH,
  },
  {
    n: '04',
    title: 'Bio-Scan Health Assessment',
    desc: 'A non-invasive assessment with an 80+ page report, approximately one hour of personal feedback and a personalised health summary with practical first steps.',
    path: ROUTES.SERVICES_SCANS,
  },
  {
    n: '05',
    title: 'Courses & Workshops',
    desc: 'Transformational educational programmes exploring herbal medicine, holistic health, anatomy, nutrition, traditional healing systems, and wellbeing. In-person, online, and community formats.',
    path: ROUTES.SERVICES_COURSES,
  },
  {
    n: '06',
    title: 'Herbal Walks & Nature Education',
    desc: 'Immersive plant education reconnecting individuals to the healing intelligence of local plants, trees, and ecosystems. Running for 15+ years across the UK.',
    path: ROUTES.TRAINING,
  },
  {
    n: '07',
    title: 'Public Speaking & Programmes',
    desc: "Educational talks and wellness programmes for community organisations, schools, corporate settings, local government, festivals, and women's groups.",
    path: ROUTES.WORK_WITH_ME,
  },
]
